<template>
	<el-button v-bind="{...$attrs, ...$props, 'data-cy': dataLabel}" :disabled="isDisabled" :icon="iconOnRight ? undefined : icon" :class="baseClass"
		v-on="{ ...$listeners, click: clickEvent }">
		<template v-if="showLabel">
			{{ LocalizedPopisostatni }} <i v-if="iconOnRight" :class="icon" class="el-icon-right" />
		</template>
		<slot />
	</el-button>
</template>

<script>
import { DmsBaseComponent } from '#components/dms/common/base';
import { BUTTON_TYPES } from '#components/@types/button';

export default DmsBaseComponent.extend({
	name: 'DmsButton',
	props: {
		text: String,
		icon: String,
		iconOnRight: Boolean,
		loading: Boolean,
		type: {
			type: String,
			in: BUTTON_TYPES,
		},
		noLabelAlign: { type: Boolean, default: false },
	},
	computed: {
		LocalizedPopisostatni() {
			return this.text || this.LocalizePopisostatni(this.labelKey);
		},
		showLabel() {
			return !!(this.labelKey || this.text);
		},
		hasClickEvent() {
			return this.$listeners && this.$listeners.click;
		},
		baseClass() {
			return { 'frm-item-label-margin': this.noLabelAlign };
		},
		dataLabel() {
			return this.$attrs['data-cy'] ? this.$attrs['data-cy'] : this.labelKey;
		},
	},
	methods: {
		clickEvent(event) {
			if (this.hasClickEvent) {
				this.$emit('click', event);
			} else {
				console.warn(`${this.LocalizedPopisostatni} - Button click not implemented`);
			}
		},
	},
});
</script>
